import React, { Component } from 'react';
import './App.css';
import { HashRouter as Router } from 'react-router-dom';
import Content from './Content';
import { connect } from 'react-redux';
import { getCurrentClient } from './Actions/Clients';
import { getCurrentUser } from './Actions/Users';
import { getPortalUsers } from './Actions/PortalUsers';

import MainMenu from './MainMenu';
import MenuToggle from './MenuToggle';

import { withConnection } from '@zorgconnect/shared-portal/Context/Connection';

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = (dispatch) => ({
    // getCurrentFreelancer: () => dispatch(getCurrentFreelancer()),
    getCurrentClient: () => dispatch(getCurrentClient()),
    getCurrentUser: () => dispatch(getCurrentUser()),
    getPortalUsers: () => dispatch(getPortalUsers())
})


class App extends Component {



    componentDidMount() {

        let { getCurrentClient, getCurrentUser, getPortalUsers } = this.props;
        getCurrentClient && getCurrentClient();
        getCurrentUser && getCurrentUser();
        getPortalUsers && getPortalUsers();

    }
    // account
    // accounts-outline
    // border-color


    // account Mijn planning
    // accounts-outline Cliënten / Planning
    // border-color Uren accorderen

    render() {
        
        return (
            <Router>
                <div className="portal">

                    <div className="header">

                    <MenuToggle />
                    <h2>U Staat centraal zorgconnect</h2>

                    </div>

                    <div className="main-container">

                        <MainMenu  />


                        <Content />
                    </div>
                </div>
            </Router>
        );
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(withConnection(App));

